<template>
  <div
    class="modal-overlay"
    v-if="mostrar"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h3>Editar Sigla</h3>
        <button
          class="fechar"
          @click="fechar"
        >
          &times;
        </button>
      </div>
      <div
        class="modal-body"
        v-if="verificando"
      >
        <p>Verificando permissões...</p>
      </div>
      <div
        class="modal-body"
        v-else-if="!ehCoordenador"
      >
        <p>Apenas o coordenador da ação pode alterar a sigla.</p>
        <button
          class="btn-salvar"
          @click="fechar"
          style="margin-top: 15px"
        >
          Ok
        </button>
      </div>
      <div
        class="modal-body"
        v-else
      >
        <div class="form-group">
          <label>Sigla da Ação (Máximo 10 caracteres)</label>
          <input
            type="text"
            v-model="sigla"
            maxlength="10"
            placeholder="Ex: EXT2024"
            class="input-estilizado"
          />
        </div>
        <div class="form-group">
          <label>Cor da Sigla</label>
          <div style="display: flex; gap: 10px; align-items: center">
            <input
              type="color"
              v-model="cor"
              class="input-cor"
            />
            <span>{{ cor }}</span>
          </div>
        </div>
        <div class="modal-actions">
          <button
            class="btn-cancelar"
            @click="fechar"
          >
            Cancelar
          </button>
          <button
            class="btn-salvar"
            @click="salvar"
            :disabled="salvando"
          >
            {{ salvando ? "Salvando..." : "Salvar" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import acaoService from "@/service/acaoService";

const props = defineProps({
  mostrar: Boolean,
  acaoId: [String, Number],
  siglaAtual: String,
  corAtual: String,
});

const emit = defineEmits(["fechar", "atualizado"]);

const verificando = ref(true);
const ehCoordenador = ref(false);
const salvando = ref(false);

const sigla = ref(props.siglaAtual || "");
const cor = ref(props.corAtual || "#482a89");

watch(
  () => props.mostrar,
  async (newMostrar) => {
    if (newMostrar && props.acaoId) {
      sigla.value = props.siglaAtual || "";
      cor.value = props.corAtual || "#482a89";
      try {
        verificando.value = true;
        const response = await acaoService.verificarCoordenador(props.acaoId);
        ehCoordenador.value = !!response;
      } catch (e) {
        console.error(e);
        ehCoordenador.value = false;
      } finally {
        verificando.value = false;
      }
    }
  },
  { immediate: true }
);

function fechar() {
  emit("fechar");
}

async function salvar() {
  if (!sigla.value || sigla.value.trim() === "") {
    alert("A sigla não pode ser vazia.");
    return;
  }

  if (sigla.value.length > 10) {
    alert("A sigla deve ter no máximo 10 caracteres.");
    return;
  }

  try {
    salvando.value = true;

    // Envia tanto a sigla quanto a cor para a API
    if (sigla.value !== props.siglaAtual || cor.value !== props.corAtual) {
      await acaoService.editarSigla(props.acaoId, sigla.value, cor.value);
    }

    alert("Configurações atualizadas com sucesso!");
    emit("atualizado", { sigla: sigla.value, corSigla: cor.value });
    fechar();
  } catch (error) {
    alert(
      "Erro ao atualizar sigla. Verifique se você tem permissão e tente novamente."
    );
  } finally {
    salvando.value = false;
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-header {
  background-color: #482a89;
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.2rem;
}

.fechar {
  background: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-weight: 500;
  color: #333;
}

.input-estilizado {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
}

.input-cor {
  width: 50px;
  height: 40px;
  padding: 0;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.btn-cancelar {
  padding: 8px 16px;
  background-color: #ccc;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.btn-salvar {
  padding: 8px 16px;
  background-color: #482a89;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.btn-salvar:disabled {
  background-color: #a08dc2;
  cursor: not-allowed;
}
</style>
